import React, { useState, useEffect, useRef } from "react";
import { toast } from "react-toastify";

import './QuotationResponseModal.css';

const QuotationResponseModal = ({ action, quotationId, onClose }) => {
  const [form, setForm] = useState({
    mobile: "",
    email: "",
    otp: ["", "", "", "", "", ""],
    description: "",
  });

  const [step, setStep] = useState(1);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const otpRefs = useRef([]);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const mobileFromUrl = urlParams.get("mobile");

    if (mobileFromUrl) {
      setForm((prev) => ({ ...prev, mobile: mobileFromUrl }));
    } else {
      const storedMobile = localStorage.getItem("user_mobile");
      if (storedMobile) {
        setForm((prev) => ({ ...prev, mobile: storedMobile }));
      } else if (quotationId) {
        fetch(`https://100billionrealestate.com/api/quotations/${quotationId}`)
          .then((res) => res.json())
          .then((data) => {
            if (data?.mobile || data?.email) {
              setForm((prev) => ({
                ...prev,
                mobile: data.mobile || "",
                email: data.email || ""
              }));
            }
          })
          .catch((err) => {
            console.error("Fetch failed:", err);
          });
      }
    }
  }, [quotationId]);

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleNext = async () => {
    const { mobile, email } = form;
    if (!mobile && !email) {
      return toast.error("Enter either mobile or email");
    }

    if (mobile && !/^\d{10}$/.test(mobile)) {
      return toast.error("Enter valid 10-digit mobile");
    }

    try {
      const res = await fetch("https://100billionrealestate.com/api/send-otp", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ mobile: mobile || null, email: email || null }),
      });

      const result = await res.json();
      if (res.ok) {
        toast.success("OTP sent successfully");
        setStep(2);
      } else {
        toast.error(result.message || "Failed to send OTP");
      }
    } catch (err) {
      toast.error("Error sending OTP");
    }
  };

  const handleOTPChange = (index, value) => {
    if (!/^\d?$/.test(value)) return; // allow only 0-9 or empty

    const otp = [...form.otp];
    otp[index] = value;
    setForm((prev) => ({ ...prev, otp }));

    if (value && index < 5) {
      otpRefs.current[index + 1]?.focus();
    }
  };

 const handleOTPVerify = async () => {
  const combined = form.otp.join("");
  if (combined.length !== 6 || form.otp.includes("")) {
    return toast.error("Enter complete 6-digit OTP");
  }

  try {
    const res = await fetch("https://100billionrealestate.com/api/verify-otp", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        mobile: form.mobile || null,
        email: form.email || null,
        otp: combined,
      }),
    });

    const result = await res.json();
    if (res.ok) {
      toast.success("OTP verified successfully");
      setStep(3); // ✅ Only proceed to next step after verification
    } else {
      toast.error(result.message || "OTP verification failed");
    }
  } catch (err) {
    toast.error("Error verifying OTP");
  }
};


  const handleSubmit = async () => {
    if (!form.description && action !== "reject") {
      return toast.error("Please enter a description");
    }

    setIsSubmitting(true);
    try {
      const res = await fetch("https://100billionrealestate.com/api/quotation-response", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          quotationId,
          action,
          description: form.description || "",
  mobile: form.mobile || "",
  email: form.email || "",
        }),
      });

      const result = await res.json();
      if (res.ok) {
        toast.success("Response recorded successfully");
  setTimeout(() => {
    onClose();
  }, 1500); // wait 1.5 seconds before closing modal



      } else {
        toast.error(result.message || "Submission failed");
      }
    } catch (err) {
      toast.error("Error submitting response");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="popup-form">
      <h3>{action.toUpperCase()} Proposal</h3>

      {/* Reject Flow (no OTP) */}
      {action === "reject" && step === 1 && (
        <>
          <textarea
            name="description"
            placeholder="Reason for rejection"
            value={form.description}
            onChange={handleChange}
          />
          <button onClick={handleSubmit} disabled={isSubmitting}>
            {isSubmitting ? "Submitting..." : "Submit"}
          </button>
        </>
      )}

      {/* Accept / Counter Flow */}
      {(action === "accept" || action === "counter") && (
        <>
          {step === 1 && (
            <>
              <input
                name="mobile"
                placeholder="Mobile (optional)"
                value={form.mobile}
                onChange={handleChange}
              />
              <input
                name="email"
                placeholder="Email"
                value={form.email}
                onChange={handleChange}
              />
              <button onClick={handleNext}>Send OTP</button>
            </>
          )}

          {step === 2 && (
            <>
              <div className="otp-boxes">
                {form.otp.map((digit, i) => (
                  <input
                    key={i}
                    maxLength={1}
                    className="otp-input"
                    value={digit}
                    ref={(el) => (otpRefs.current[i] = el)}
                    onChange={(e) => handleOTPChange(i, e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Backspace" && !form.otp[i] && i > 0) {
                        otpRefs.current[i - 1]?.focus();
                      }
                    }}
                  />
                ))}
              </div>
              <button onClick={handleOTPVerify}>Verify OTP</button>
            </>
          )}

          {step === 3 && (
            <>
              <textarea
                name="description"
                placeholder={
                  action === "counter"
                    ? "Describe your counter proposal"
                    : "Any message"
                }
                value={form.description}
                onChange={handleChange}
              />
              <button onClick={handleSubmit} disabled={isSubmitting}>
                {isSubmitting ? "Submitting..." : "Submit"}
              </button>
            </>
          )}
        </>
      )}

      <button onClick={() => onClose("cancel")} style={{ marginTop: "10px", background: "#ccc" }}>
        Cancel
      </button>
  
    </div>
    
  );
};

export default QuotationResponseModal;
